import { css, useTheme } from '@emotion/react';
import { memo } from 'react';
import Loader from 'react-loader-spinner';

import { styled } from '../../styled';
import type { Theme } from '../../theme/interface/detailed';
import { borderRadiusFix } from '../../utils/borderRadiusFix';

type Unpack<A = unknown[]> = A extends Array<infer R> ? R : never;
const POSSIBLE_TYPES = [
	'Audio',
	'BallTriangle',
	'Bars',
	'Circles',
	'Grid',
	'Hearts',
	'Oval',
	'Puff',
	'Rings',
	'TailSpin',
	'ThreeDots',
	'Watch',
	'Triangle',
	'Plane',
] as const;
const validateThemeType = (v: string): boolean => {
	return POSSIBLE_TYPES.includes(v as Unpack<typeof POSSIBLE_TYPES>);
};
export const LoadingAnimation = styled(
	memo(({ className }: { className: string }) => {
		const {
			allSettings: {
				loadingAnimation: { animationType, iconColor, animationSize },
			},
		} = useTheme() as Theme;
		return (
			<div className={className}>
				<Loader
					type={validateThemeType(animationType) ? animationType : 'Oval'}
					color={iconColor}
					height={animationSize}
					width={animationSize}
				/>
			</div>
		);
	})
)(
	({ theme }: { theme: Theme }) =>
		css`
			align-items: center;
			backdrop-filter: blur(20px);
			background: #fff;
			border-radius: ${theme.allSettings.containers.chatContainer.borderRadius};
			display: flex;
			height: 100%;
			justify-content: center;
			position: absolute;
			opacity: 0.8;
			width: 100%;
			z-index: 10000;
		`,
	borderRadiusFix()
);
